export default {
    prototype: {
        defaultMsg: "暫無內容",
        defaultTitle: "提示",
        confirmButtonText: "確定",
        cancelButtonText: "取消",
    },
    separator: "、",
};
